//Api or Services
import { modulesName } from '@/modules';
import AcademicYearService from '@/modules/common/academicyear.api';
import LocationService from '@/modules/common/location.api';
import ReferralService from '@/modules/referral/api';
import providerReasons from '@/utils/constants/pei/referral/providerReasonsTypes';
//Constants
import SearchMode from '@/utils/constants/pei/referral/searchMode';
import {
  ACTION_TYPES,
  MUTATION_TYPES,
  SET_REFERRAL_DETAILS,
  SET_REFERRAL_NEW_BILLING_CENTER,
  SET_REFERRAL_REJECTION_REASON,
  SET_REFERRAL_RESULTS,
  // eslint-disable-next-line prettier/prettier
  SET_REFERRAL_SERVICE_CENTER,
} from './types';

const actions = {
  async [ACTION_TYPES.GET_REFERRALS]({ commit, getters }, { filters }) {
    //set last filtered
    commit('setLastFiltered', filters);

    if (getters.getServiceCenter.length == 0) {
      const responseCenters = await ReferralService.getAllBillingCenters();
      if (responseCenters) {
        commit(SET_REFERRAL_SERVICE_CENTER, responseCenters);
      }
    }

    const response = await ReferralService.getThrpyReferrals(filters);
    if (response) {
      commit(SET_REFERRAL_RESULTS, response);
    }
  },
  async [ACTION_TYPES.GET_REFERRAL_DETAILS]({ commit }, admissionId) {
    const response = await ReferralService.getthrpyreferraldetails(admissionId);
    if (response) {
      commit(SET_REFERRAL_DETAILS, { admissionId, data: response });
    }
  },
  //Get Defaults Filters for ReferralManagment
  async [ACTION_TYPES.GET_FILTERS](context, payload) {
    let { searchMode, academicYearId } = payload;
    let requests = [];

    //Basic init
    if (
      searchMode == SearchMode.Basic &&
      context.state.referral.filters.academicyears.length == 0
    ) {
      let resources = ['0709', '0704']; //Resources to loaded

      requests = [
        await AcademicYearService.getReferralServiceAcademicYears(),
        //This don't return nothing but call all in one call
        await context.dispatch(
          `${modulesName.commonModuleName}/getResources`,
          resources,
          { root: true }
        ),
        await context.dispatch(
          `${modulesName.commonModuleName}/getCurrentAcademicYear`,
          null,
          { root: true }
        ),
      ];
      const [academicyears] = await Promise.all(requests);
      if (academicyears) {
        context.commit(MUTATION_TYPES.SET_REFERRAL_ACADEMY_YEAR, academicyears);
      }
    } else {
      let isCompleted = false;
      //Validate if filters is already persited by academicyearId
      const { selectedAcademicYearByFilters } = context.state.referral.filters;

      const isAlreadySearch =
        selectedAcademicYearByFilters != null &&
        selectedAcademicYearByFilters.searchMode == payload.searchMode &&
        selectedAcademicYearByFilters.academicYearId == payload.academicYearId;

      if (isAlreadySearch) return;

      const requestLocation = {
        academicYearId: academicYearId,
      };
      switch (searchMode) {
        case SearchMode.Standard:
          {
            //Center ID: (Permissions is pendient to implement )
            const {
              admissionStatus,
              admissionReferralTypes,
            } = context.state.referral.filters;
            requests = [
              ...requests,
              ...[
                await ReferralService.getAdmissionStatusReasons(),
                await LocationService.getCenters(requestLocation),
              ],
            ];
            //Only one requested is need
            if (admissionStatus.length == 0) {
              requests = [
                ...requests,
                await ReferralService.getAdmissionStatus(),
                await ReferralService.getAdmissionReferralTypes(),
                await ReferralService.getServiceModalityTypes(),
                await ReferralService.getDisciplineTypes(),
              ];
            }
            const [
              admissionStatusReasonsList,
              centers,
              admissionStatusesList,
              admissionReferralTypesList,
              serviceModalityTypes,
              disciplines,
            ] = await Promise.all(requests);

            if (centers && centers.length) {
              context.commit(MUTATION_TYPES.SET_REFERRAL_CENTERS, centers);
              isCompleted = true;
            }
            if (
              admissionStatus.length == 0 &&
              admissionStatusesList != undefined
            ) {
              context.commit(
                MUTATION_TYPES.SET_REFERRAL_ADMISSION_STATUS,
                admissionStatusesList
              );
            }
            //Only Once
            if (
              admissionReferralTypes.length == 0 &&
              admissionReferralTypesList != undefined
            ) {
              context.commit(
                MUTATION_TYPES.SET_REFERRAL_ADMISSION_REFERRAL_TYPES,
                admissionReferralTypesList
              );
              context.commit(
                MUTATION_TYPES.SET_REFERRAL_DISCIPLINE,
                disciplines
              );
            }

            if (serviceModalityTypes && serviceModalityTypes.length) {
              context.commit(
                MUTATION_TYPES.SET_SERVICE_MODALITY_TYPES,
                serviceModalityTypes
              );
            }

            if (
              admissionStatusReasonsList &&
              admissionStatusReasonsList.length
            ) {
              context.commit(
                MUTATION_TYPES.SET_REFERRAL_ADMISSION_STATUS_REASONS,
                admissionStatusReasonsList
              );
            }
          }
          break;
        case SearchMode.Advanced:
          {
            requests = [
              ...[
                await ReferralService.getAvailableMonthsByAcademicYear(
                  academicYearId
                ),
                await ReferralService.getCompaniesByAcademicyearId(
                  academicYearId
                ),
              ],
            ];
            if (context.state.referral.filters.locationTypes.length == 0) {
              requests = [
                ...requests,
                await ReferralService.getLocationTypes(),
                await ReferralService.getDisciplineTypes(),
              ];
            }
            const [
              months,
              providers,
              locationTypes,
              disciplines,
            ] = await Promise.all(requests);

            if (providers && providers.length) {
              context.commit(MUTATION_TYPES.SET_REFERRAL_MONTHS, months);
              context.commit(MUTATION_TYPES.SET_REFERRAL_PROVIDERS, providers);
              if (locationTypes != undefined) {
                context.commit(
                  MUTATION_TYPES.SET_REFERRAL_LOCATION_TYPES,
                  locationTypes
                );
                context.commit(
                  MUTATION_TYPES.SET_REFERRAL_DISCIPLINE,
                  disciplines
                );
              }
              isCompleted = true;
            }
          }
          break;
        case SearchMode.WaitList:
          {
            requests = [await LocationService.getCenters(requestLocation)];
            if (context.state.referral.filters.disciplines.length == 0) {
              requests = [
                ...requests,
                await ReferralService.getDisciplineTypes(),
              ];
              const [centers, disciplines] = await Promise.all(requests);
              if (centers != undefined) {
                context.commit(MUTATION_TYPES.SET_REFERRAL_CENTERS, centers);
              }
              if (disciplines != undefined) {
                context.commit(
                  MUTATION_TYPES.SET_REFERRAL_DISCIPLINE,
                  disciplines
                );
              }

              isCompleted = true;
            }
          }
          break;
      }

      if (isCompleted) {
        //Set lasted academic year and search mode
        context.commit(
          MUTATION_TYPES.SET_SELECTED_ACADEMIC_YEAR_BY_FILTER,
          payload
        );
      }
    }
  },
  //Get Filters Standard & Advanced
  async [ACTION_TYPES.GET_FILTERS_BY_STATUS](context, payload) {
    let { searchMode, statusId } = payload;
    let requests = [];
    if (
      searchMode == SearchMode.Standard ||
      searchMode == SearchMode.Advanced
    ) {
      requests = [await ReferralService.getAdmissionStatusReasons(statusId)];
    }
    const [admissionStatusReasonsList] = await Promise.all(requests);
    if (admissionStatusReasonsList && admissionStatusReasonsList.length) {
      context.commit(
        MUTATION_TYPES.SET_REFERRAL_ADMISSION_STATUS_REASONS,
        admissionStatusReasonsList
      );
    }
  },
  //Get Filters Advaced depends by Providers
  async [ACTION_TYPES.GET_FILTERS_BY_PROVIDER](context, payload) {
    let { searchMode, academicYearId, providerId } = payload;
    let requests = [];
    if (searchMode == SearchMode.Advanced) {
      requests = [
        await ReferralService.getCenters(academicYearId, providerId),
        await ReferralService.getMunicipalities(academicYearId, providerId),
        await ReferralService.getLocationServices(academicYearId, providerId),
        await ReferralService.getSpecialists(academicYearId, providerId),
      ];
    }
    const [
      centers,
      municipalities,
      locationServices,
      specialists,
    ] = await Promise.all(requests);
    context.commit(MUTATION_TYPES.SET_REFERRAL_CENTERS, centers);
    context.commit(MUTATION_TYPES.SET_REFERRAL_MUNICIPALITIES, municipalities);
    context.commit(
      MUTATION_TYPES.SET_REFERRAL_LOCATIONS_SERVICES,
      locationServices
    );
    context.commit(MUTATION_TYPES.SET_REFERRAL_SPECIALISTS, specialists);
  },
  //Get Filters By Center
  async [ACTION_TYPES.GET_FILTERS_BY_CENTER](context, payload) {
    let { searchMode, academicYearId, providerId, centerId } = payload;
    let requests = [];

    if (searchMode == SearchMode.Standard) {
      requests = [
        await ReferralService.getMunicipalities(
          academicYearId,
          providerId,
          centerId
        ),
      ];
    }

    if (searchMode == SearchMode.Advanced) {
      requests = [
        await ReferralService.getMunicipalities(
          academicYearId,
          providerId,
          centerId
        ),
        await ReferralService.getLocationServices(
          academicYearId,
          providerId,
          centerId
        ),
        await ReferralService.getSpecialists(
          academicYearId,
          providerId,
          centerId
        ),
      ];
    }

    const [municipalities, locationServices, specialists] = await Promise.all(
      requests
    );
    context.commit(MUTATION_TYPES.SET_REFERRAL_MUNICIPALITIES, municipalities);
    context.commit(
      MUTATION_TYPES.SET_REFERRAL_LOCATIONS_SERVICES,
      locationServices
    );
    context.commit(MUTATION_TYPES.SET_REFERRAL_SPECIALISTS, specialists);
  },
  //Get Filters by Municipality
  async [ACTION_TYPES.GET_FILTERS_BY_MUNICIPALITY](context, payload) {
    let {
      searchMode,
      academicYearId,
      providerId,
      centerId,
      municipalityId,
    } = payload;
    let requests = [];
    switch (searchMode) {
      case SearchMode.Standard:
        {
          const request = {
            academicYearId: academicYearId,
            municipalityId: municipalityId,
          };
          requests = [...[await LocationService.getSchools(request)]];
          const [schools] = await Promise.all(requests);

          if (schools && schools.length) {
            context.commit(MUTATION_TYPES.SET_REFERRAL_SCHOOL, schools);
          }
        }
        break;
      case SearchMode.Advanced: {
        requests = [
          await ReferralService.getLocationServices(
            academicYearId,
            providerId,
            centerId,
            municipalityId
          ),
          await ReferralService.getSpecialists(
            academicYearId,
            providerId,
            centerId,
            municipalityId
          ),
        ];

        const [locationServices, specialists] = await Promise.all(requests);
        context.commit(
          MUTATION_TYPES.SET_REFERRAL_LOCATIONS_SERVICES,
          locationServices
        );
        context.commit(MUTATION_TYPES.SET_REFERRAL_SPECIALISTS, specialists);
      }
    }
  },
  async [ACTION_TYPES.GET_FILTERS_BY_LOCATION_TYPE](context, payload) {
    let {
      searchMode,
      academicYearId,
      providerId,
      centerId,
      municipalityId,
      locationTypeId,
    } = payload;
    let requests = [];
    //Get Filters required always academic year (Persited and not)
    if (searchMode == SearchMode.Advanced) {
      requests = [
        await ReferralService.getLocationServices(
          academicYearId,
          providerId,
          centerId,
          municipalityId,
          locationTypeId
        ),
        await ReferralService.getSpecialists(
          academicYearId,
          providerId,
          centerId,
          municipalityId,
          locationTypeId
        ),
      ];
    }
    const [locationServices, specialists] = await Promise.all(requests);
    context.commit(
      MUTATION_TYPES.SET_REFERRAL_LOCATIONS_SERVICES,
      locationServices
    );
    context.commit(MUTATION_TYPES.SET_REFERRAL_SPECIALISTS, specialists);
  },
  async [ACTION_TYPES.GET_FILTERS_BY_LOCATION_SERVICE](context, payload) {
    let {
      searchMode,
      academicYearId,
      providerId,
      centerId,
      municipalityId,
      locationTypeId,
      locationServiceId,
    } = payload;
    let requests = [];

    if (searchMode == SearchMode.Advanced) {
      requests = [
        await ReferralService.getSpecialists(
          academicYearId,
          providerId,
          centerId,
          municipalityId,
          locationTypeId,
          locationServiceId
        ),
      ];
    }
    const [specialists] = await Promise.all(requests);
    context.commit(MUTATION_TYPES.SET_REFERRAL_SPECIALISTS, specialists);
  },
  async [ACTION_TYPES.GET_BILLING_CENTERS]({ commit }) {
    const response = await ReferralService.getAllBillingCenters();
    if (response) {
      commit(SET_REFERRAL_SERVICE_CENTER, response);
    }
  },
  async [ACTION_TYPES.UPDATE_BILLING_CENTER](
    { commit },
    {
      admissionId,
      newBillingCenterId,
      newBillingCenterName,
      disciplineTypeId,
      studentSieId,
      academicYearId,
      companyId,
    }
  ) {
    const response = await ReferralService.updateBillingCenter(
      newBillingCenterId,
      disciplineTypeId,
      studentSieId,
      academicYearId,
      companyId
    );
    if (response) {
      commit(SET_REFERRAL_NEW_BILLING_CENTER, {
        admissionId,
        data: { newBillingCenterId, newBillingCenterName },
      });
    }
  },

  //Admission Rejection History
  async [ACTION_TYPES.GET_ADMISSION_REJECTION_HISTORY](
    { commit },
    { admissionId, pageConfig }
  ) {
    const response = await ReferralService.admissionrejectionhistory(
      admissionId,
      pageConfig
    );
    if (response) {
      commit(MUTATION_TYPES.SET_ADMISSION_REJECTION_HISTORY, response);
    }
  },
  async getSchoolByAdmissionId({ commit }, admissionId) {
    const { data: response } = await ReferralService.getSchoolByAdmissionId(
      admissionId
    );
    if (response) {
      commit('setAdmissionSchool', response);
    }
  },
  async getProviderReasons({ commit }, optionId) {
    const { data: response } = await ReferralService.getProviderReasons(
      optionId
    );
    if (response) {
      commit('setProviderReasons', response);
    }
  },
  async getProviderDetail({ commit }, admissionId) {
    const { data: response } = await ReferralService.getProviderDetail(
      admissionId
    );
    if (response) {
      commit('setProviderDetail', response);
    }
  },
  async getSchoolMunicipality(context, { admissionId, municipalityId }) {
    const { data: response } = await ReferralService.getSchoolByMunicipality(
      admissionId,
      municipalityId
    );
    await context.dispatch(
      'getProviderReasons',
      providerReasons.SCHOOL_MUNICIPALITY
    );
    if (response) {
      context.commit('setSchoolMunicipality', response);
    }
  },
  async getSchoolHome(context, { admissionId, municipalityId }) {
    const { data: response } = await ReferralService.getProviderMunicipalities(
      admissionId,
      municipalityId
    );
    await context.dispatch(
      'getProviderReasons',
      providerReasons.MUNICIPALITY_HOME
    );
    if (response) {
      context.commit('setHomeMunicipality', response);
    }
  },
  async getSchoolHomeMunicipalitySchool(
    context,
    { admissionId, municipalityId }
  ) {
    const { data: response } = await ReferralService.getSchoolByMunicipality(
      admissionId,
      municipalityId
    );
    await context.dispatch(
      'getProviderReasons',
      providerReasons.MUNICIPALITY_HOME
    );
    if (response) {
      context.commit('setSchoolHomeMunicipalitySchool', response);
    }
  },
  async getSchoolFreeSelection(context, { admissionId, municipalityId }) {
    const { data: response } = await ReferralService.getProviderMunicipalities(
      admissionId,
      municipalityId
    );
    await context.dispatch(
      'getProviderReasons',
      providerReasons.FREE_SELECTION
    );
    if (response) {
      context.commit('setFreeSelectionMunicipality', response);
    }
  },

  async getSchoolFreeSelectionMunicipalitySchool(
    context,
    { admissionId, municipalityId }
  ) {
    const { data: response } = await ReferralService.getSchoolByMunicipality(
      admissionId,
      municipalityId
    );
    await context.dispatch(
      'getProviderReasons',
      providerReasons.FREE_SELECTION
    );
    if (response) {
      context.commit('setSchoolFreeSelectionMunicipalitySchool', response);
    }
  },
  async saveRejectionLinkAdmission(_, data) {
    return await ReferralService.saveRejectionLinkAdmission(data);
  },
  async [ACTION_TYPES.GET_REFERRAL_REJECTION_REASON](
    { getters, commit },
    { type }
  ) {
     if (getters.getReferralRejectionReasons.length == 0) {
      const {
        data: response,
      } = await ReferralService.getRejectionReasonsByType(type);
      if (response) {
        commit(SET_REFERRAL_REJECTION_REASON, response);
      }
      return [];
    }
  },
  async [ACTION_TYPES.DENEGATE_REFERRAL](_, payload ) {
    return await ReferralService.denegateReferral(payload);
  },
  //Last Action get all based in persisted data
};
export default actions;
